export const CHANGE_INPUT_SEARCH = "CHANGE_INPUT_SEARCH";
export const CHANGE_INPUT_RIVERINFO = "CHANGE_INPUT_RIVERINFO";
export const CHANGE_INPUT = "CHANGE_INPUT";
export const CLEAN_FORM = "CLEAN_FORM";
export const SUBMIT_FORM = "SUBMIT_FORM";
